import { http } from "./http.js";

async function getSettings() {
  const response = await http.get("default-settings");
  return response;
}

async function editSettings(settings) {
  const response = await http.post("default-settings", settings);
  return response;
}
export { getSettings, editSettings };
